import { useInfiniteQuery } from "@tanstack/react-query";
import { searchQuery } from "../utility/httpActions/searchActions";

const buildParams = ({ q, categories, deliveryMethods, paymentMethods, paymentTimings, productSort, shopSort, state, country }) => ({
  q: q || undefined,
  categories: categories?.length ? categories.join(",") : undefined,
  deliveryMethods: deliveryMethods?.length ? deliveryMethods.join(",") : undefined,
  paymentMethods: paymentMethods?.length ? paymentMethods.join(",") : undefined,
  paymentTimings: paymentTimings?.length ? paymentTimings.join(",") : undefined,
  productSort: productSort || undefined,
  shopSort: shopSort || undefined,
  state: state || undefined,
  country: country || undefined,
});

const isEnabled = ({ q, categories, deliveryMethods, paymentMethods, paymentTimings, state, country }) =>
  !!(q && q.trim()) ||
  !!categories?.length ||
  !!deliveryMethods?.length ||
  !!paymentMethods?.length ||
  !!paymentTimings?.length ||
  !!state ||
  !!country;

const PAGE_SIZE = 12;

// Mirrors ngwaahia-mobile/utils/hooks/useSearch.js
const useSearch = (filters = {}) => {
  const { q, categories, deliveryMethods, paymentMethods, paymentTimings, productSort, shopSort, state, country } = filters;
  const enabled = isEnabled(filters);
  const sharedKey = [q, categories, deliveryMethods, paymentMethods, paymentTimings, productSort, shopSort, state, country];
  const params = buildParams(filters);

  const productsQuery = useInfiniteQuery({
    queryKey: ["search", "products", ...sharedKey],
    queryFn: ({ pageParam = 1 }) => searchQuery({ ...params, type: "products", page: pageParam, limit: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage.products;
      return p.currentPage < p.totalPages ? p.currentPage + 1 : undefined;
    },
    enabled,
  });

  const shopsQuery = useInfiniteQuery({
    queryKey: ["search", "shops", ...sharedKey],
    queryFn: ({ pageParam = 1 }) => searchQuery({ ...params, type: "shops", page: pageParam, limit: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage.shops;
      return p.currentPage < p.totalPages ? p.currentPage + 1 : undefined;
    },
    enabled,
  });

  const peopleQuery = useInfiniteQuery({
    queryKey: ["search", "people", ...sharedKey],
    queryFn: ({ pageParam = 1 }) => searchQuery({ ...params, type: "people", page: pageParam, limit: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage.users;
      return p.currentPage < p.totalPages ? p.currentPage + 1 : undefined;
    },
    enabled,
  });

  return { productsQuery, shopsQuery, peopleQuery, enabled };
};

export default useSearch;
